module.exports = __webpack_public_path__ + "img/SpotiFRESH.bde53805.svg";